export interface FilterCategory {
  id: number;
  name: string;
  children?: FilterCategory[];
}

export const functionCategories: FilterCategory[] = [
  {
    id: 1,
    name: "Chatbot",
    children: [
      { id: 11, name: "Customer Support" },
      { id: 12, name: "Personal Assistant" }
    ]
  },
  {
    id: 2,
    name: "Image Generation",
    children: [
      { id: 21, name: "Art Creation" },
      { id: 22, name: "Photo Editing" }
    ]
  },
  {
    id: 3,
    name: "Productivity",
    children: [
      { id: 31, name: "Writing Assistant" },
      { id: 32, name: "Task Management" }
    ]
  }
];

export const pricingCategories: FilterCategory[] = [
  { id: 1, name: "Free" },
  { id: 2, name: "Freemium" },
  { id: 3, name: "Subscription" },
  { id: 4, name: "One-time Purchase" }
];

export const industryCategories: FilterCategory[] = [
  { id: 1, name: "Business" },
  { id: 2, name: "Education" },
  { id: 3, name: "Healthcare" },
  { id: 4, name: "Marketing" }
];